// User types (levels) shown across the User Creation area.
// Display text only: level numbers, routes and API fields are unchanged.

export const LEVEL_NAMES = Object.freeze({
  1: 'Super Admin',
  2: 'State Head',
  3: 'State Officer',
  4: 'Q-Pay Centre',
  5: 'Q-Pay Agent',
});

export const levelName = (level) => LEVEL_NAMES[Number(level)] || (level !== undefined && level !== null ? String(level) : '');
